import { FeedType } from '../models';
import { createFeedTypeQueryParam } from '../create-feed-type-query-param';
import { setSavedAction } from '../../../../common/store/saved-action/set-saved-action';
import { GO_TO_MY_POSTS } from '../../../constants/interactions';
import { requestLoginPromisified } from '../../../actions/request-login';
import { navigateWithinForum } from '../../../../common/actions/navigate-within-forum';
import { RootState } from '../../../reducers/root-state';
import { getCurrentUser } from '../../../../common/store/current-user/current-user-selectors';
import createAction from '../../../../common/services/create-action';

export const NAVIGATE_TO_MAIN_TAB = 'headerTabs/NAVIGATE_TO_MAIN_TAB';

const navigateToMainTabStart = createAction(NAVIGATE_TO_MAIN_TAB);

export const navigateToMainTab = (id: FeedType, feedType: FeedType | null) => (
  dispatch: (action: any) => void,
  getState: () => RootState,
) => {
  const state = getState();
  const isAuthenticated = !!getCurrentUser(state);

  if (feedType === FeedType.MyPosts && !isAuthenticated) {
    dispatch(
      setSavedAction({
        action: GO_TO_MY_POSTS,
        args: `/?${createFeedTypeQueryParam(FeedType.MyPosts)}`,
      }),
    );
    return dispatch(requestLoginPromisified(['login']));
  }

  dispatch(navigateToMainTabStart(id));
  dispatch(navigateWithinForum(`${feedType ? `/?${createFeedTypeQueryParam(feedType)}` : '/'}`));
};
